import { useState } from "react";
import { useTranslation } from "react-i18next";

const MonthDropDown = ({sendMonthDataFromChild, monthValue}) => {
    const { t } = useTranslation();
    const [showMonth, setShowMonth] = useState(false);
    const months = [
        { 'id' : 1, 'name': 'january' },
        { 'id' : 2, 'name': 'february' },
        { 'id' : 3, 'name': 'march' },
        { 'id' : 4, 'name': 'april' },
        { 'id' : 5, 'name': 'may' },
        { 'id' : 6, 'name': 'june' },
        { 'id' : 7, 'name': 'july' },
        { 'id' : 8, 'name': 'august' },
        { 'id' : 9, 'name': 'september' },
        { 'id' : 10, 'name': 'october' },
        { 'id' : 11, 'name': 'november' },
        { 'id' : 12, 'name': 'december' }
    ];

    const openMonth = (e) => {
        e.preventDefault();
        setShowMonth(!showMonth);
    };

    const handleMonth = (e, value) => {
        e.preventDefault();
        setShowMonth(!showMonth);
        if(value) {
            monthValue = value.name;
        } else {
            monthValue = value;
        }
        sendMonthDataFromChild(value);
    }

    return (
        <div>
            <label className="font-medium capitalize text-sm sm:text-base">{ t('month')}</label>
            <div className="mt-1">
                <div className="inline-block relative w-full" onClick={(e) => openMonth(e)}>
                    <button className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base px-3 py-2 rounded-md inline-flex items-center">
                        <span className={monthValue.length > 0 ? "text-black capitalize" : "text-gray-dark" + " mr-1 text-xs sm:text-base"}>{monthValue.length > 0 ? t(monthValue) : t('select month')}</span>
                        <img src="../../../assets/icons/select-down.svg" alt="select-down" />                                                        
                    </button>
                    {
                        showMonth
                        ? 
                            <ul className="absolute w-full min-h-aotu max-h-44 overflow-y-auto no-scrollbar z-10 text-background-dark bg-white shadow-md rounded-md">
                                <li key="month" onClick={(e) => handleMonth((e), '')}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-xs sm:text-base">{ t('select month')}</li>
                                {months.map((value,index) => (
                                    <li key={index} onClick={(e) => handleMonth((e), value)}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-xs sm:text-base">{ t(value.name)}</li>
                                ))}
                            </ul>                            
                        : null
                    }
                </div>
            </div>
        </div>
    )
}

export default MonthDropDown;